import { Toaster as Sonner } from "sonner";
import { useTheme } from "@/hooks/use-theme";

/**
 * Toast host. Mounted once at the app root; call `toast()` from sonner
 * anywhere. The skill requires a toast on every mutation outcome.
 *
 * Styling is pinned to our tokens rather than sonner's own palette, so toasts
 * match the app in both themes.
 */
export function Toaster() {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme}
      position="bottom-right"
      // Long enough to read a failure message and act on it.
      duration={5000}
      toastOptions={{
        classNames: {
          toast:
            "group flex items-center gap-3 rounded-lg border border-border bg-card p-4 text-sm text-card-foreground shadow-lg",
          title: "font-medium",
          description: "text-muted-foreground text-xs",
          actionButton: "bg-primary text-primary-foreground rounded-md px-2 py-1 text-xs",
          cancelButton:
            "bg-secondary text-secondary-foreground rounded-md px-2 py-1 text-xs",
          success: "[&_[data-icon]]:text-success",
          error: "[&_[data-icon]]:text-destructive",
          warning: "[&_[data-icon]]:text-warning",
        },
      }}
    />
  );
}
